export const SHOW_LOADER = 'SHOW_LOADER'
export const HIDE_LOADER = 'HIDE_LOADER'
export const SHOW_LOADING_PAGE = 'SHOW_LOADING_PAGE'
export const HIDE_LOADING_PAGE = 'HIDE_LOADING_PAGE'
